// Loading screen: lock scroll while the intro animation plays.
// Fix (2026-10): if the page finishes loading after the logo animation has already
// ended, 'animationend' never fires and scroll stayed locked. A timer now always
// releases the lock when the intro (~4s) is over.
document.addEventListener('DOMContentLoaded', function () {
	var loadingElement = document.getElementById('loading');
	var INTRO_MS = 4200;

	function enableScroll() {
		document.body.style.overflow = '';
	}

	if (!loadingElement) {
		enableScroll();
		return;
	}

	var remaining = INTRO_MS - performance.now();
	if (remaining <= 0) {
		enableScroll();
		return;
	}

	document.body.style.overflow = 'hidden';
	loadingElement.addEventListener('animationend', enableScroll, { once: true });
	setTimeout(enableScroll, remaining);
});
